/* istanbul ignore file */
import React from 'react';
import { ARTIFACT_ID } from '../constants';
import ArtifactUploaderInput, { ArtifactUploaderInputProps } from './ArtifactUploaderInput';

const NoteAttachmentUploaderInput = (props: ArtifactUploaderInputProps) => {
  return <ArtifactUploaderInput {...props} artifactTypeId={ARTIFACT_ID.NOTE_ATTACHMENT} />;
};

export default NoteAttachmentUploaderInput;
